import { Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentsApiClient } from '../api-clients';

export interface AttachmentPreviewPort {
  previewQboAttachment(qboAttachmentId: string | number): Observable<unknown>;
}

export const ATTACHMENT_PREVIEW_PROVIDER = new InjectionToken<AttachmentPreviewPort>(
  'ATTACHMENT_PREVIEW_PROVIDER'
);

@Injectable({
  providedIn: 'root',
})
export class PaymentsAttachmentPreviewAdapter implements AttachmentPreviewPort {
  constructor(private paymentsApiClient: PaymentsApiClient) {}

  previewQboAttachment(qboAttachmentId: string | number): Observable<unknown> {
    return this.paymentsApiClient.previewQboAttachment(qboAttachmentId);
  }
}
